import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("columns4", component(opts));
  editor.BlockManager.add("columns4", block(opts));
};